export default __webpack_public_path__ + "static/media/rauchmelder_stockwerk0.37a283ed.png";